import { Dish } from './dish.entity';
import type { PaymentQueueItem } from './payment-queue.entity';

export class Order {
    // 订单备注
    public check_name?: string;
    // 订餐用户id
    public customer_id?: number;
    // 订餐用户名称+电话号码
    public customer_name?: string;
    // 用餐客户数量
    public customer_num?: number;
    // 外卖信息
    public delivery_info?: string;
    // 当前订单点菜数量 菜品id:菜品数量
    public dishes_number?: {
        [key: string]: number;
    };
    // 就餐方式: 0:堂吃，1:堂吃打包，2:外送，3:来店自取
    public eat_type?: number;
    // 外卖时间
    public kds_time?: Date | null;
    // 订单号
    public order_head_id?: number;
    // 创建订单时间
    public order_start_time?: Date;
    // 最早的点菜时间
    public order_time?: Date | null;
    // 厨师当前进行的轮次
    public rule_gnr_chef_turn?: string;
    // 本回合已点菜品数量
    public rule_gnr_num?: number | null;
    // 本回合开始时间
    public rule_gnr_time_start?: Date | null;
    // 回合数
    public rule_gnr_turn?: string | null;
    // 订单总金额
    public should_amount?: number | null;
    /** 应付金额（即时订单列表等接口 total_amount，列表「应付」列取此字段） */
    public total_amount?: number | null;
    /** 已付金额（即时订单列表 / 详情等接口返回的 paid_amount） */
    public paid_amount?: number | null;
    public actual_amount?: number | null;
    // 订单状态 0：未完成/已取消（历史订单中0是已取消），1：已完成
    public status?: number;
    // 桌台id
    public table_id?: number | null;
    // 桌台名称
    public table_name?: string | null;
    // 桌台状态 1.空台；2.开台；3.已送厨；4.已打预结单但未付款；5.付款超时；6.停用
    public table_status?: number;
    // 优先处理
    public is_priority?: 0 | 1;
    // 大人人数
    public adult_number?: number;
    // 小孩人数
    public child_number?: number;
    // 其他人数
    public other_number?: number;
    // 选择的菜单
    public select_menu?: string | null;
    // 最后下单时间
    public last_order_time?: Date | null;
    // 分单号
    public check_number?: number;
    // 开台人员
    public open_employee_name?: string;
    // 订单结束时间
    public order_end_time?: string;
    // 分单号
    public check_id?: string;
    // 历史订单id
    public server_id?: string;
    // 菜品数据
    public menu?: Dish[];
    // 开单人员
    public order_employee_name?: string;
    /** 折扣总额（订单详情 order_head.discount_total） */
    public discount_total?: number | null;
    /** 退菜总额（订单详情 order_head.refund_dish_total） */
    public refund_dish_total?: number | null;
    /** 改价总额（订单详情 order_head.reprice_total） */
    public reprice_total?: number | null;
    /** 菜品数量（订单详情 order_head.dish_count） */
    public dish_count?: number;
    /** 人均菜品数量（订单详情 order_head.avg_dish_per_person） */
    public avg_dish_per_person?: number;
    /** 付款队列（订单详情接口 queue） */
    public queue?: PaymentQueueItem[];
}

export type Report = {
    actual_amount?: number;
    discount_amount?: number;
    orderCondimentPrice?: number;
    orderDishesPrice?: number;
    orderServicesPrice?: number;
    order_amount_price?: number;
    paid_amount?: number;
    staging_amount?: number;
    sumPrice?: number;
    unpaid_amount?: number;
};

export enum ORDER_EAT_TYPE {
    // 堂食 0
    'DINE' = 'dine',
    // 自取 3
    'PICK' = 'pick',
    // 外卖 2
    'TAKEOUT' = 'takeout',
    // 桌台（仅用于区分桌台模式和订单模式）
    'TABLE' = 'table',
    // 打包 1
    'Package' = 'package'
}

// 外卖信息
export type DeliverInfo = {
    // 客户名称
    customer_name?: string;
    // 客户手机号
    customer_phone?: string;

}